/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import SensorV1RecordMeta from './SensorV1RecordMeta';

/**
* The SensorV1RecordResponse model module.
* @module model/SensorV1RecordResponse
* @version 2020-12-7
*/
export default class SensorV1RecordResponse {
    /**
    * Constructs a new <code>SensorV1RecordResponse</code>.
    * @alias module:model/SensorV1RecordResponse
    * @class
    * @param version {module:model/SensorV1RecordResponse.VersionEnum} センサーバージョン
    * @param timestamp {Number} 時刻
    * @param meta {module:model/SensorV1RecordMeta} 
    * @param data {Array.<Number>} データ
    */

    constructor(version, timestamp, meta, data) {
        
        
        this['version'] = version;
        this['timestamp'] = timestamp;
        this['meta'] = meta;
        this['data'] = data;
        
    }

    /**
    * Constructs a <code>SensorV1RecordResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/SensorV1RecordResponse} obj Optional instance to populate.
    * @return {module:model/SensorV1RecordResponse} The populated <code>SensorV1RecordResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SensorV1RecordResponse();
                        
            
            if (data.hasOwnProperty('version')) {
                obj['version'] = ApiClient.convertToType(data['version'], 'Number');
            }
            if (data.hasOwnProperty('timestamp')) {
                obj['timestamp'] = ApiClient.convertToType(data['timestamp'], 'Number');
            }
            if (data.hasOwnProperty('meta')) {
                obj['meta'] = SensorV1RecordMeta.constructFromObject(data['meta']);
            }
            if (data.hasOwnProperty('data')) {
                obj['data'] = ApiClient.convertToType(data['data'], ['Number']);
            }
        }
        return obj;
    }

    /**
    * センサーバージョン
    * @member {module:model/SensorV1RecordResponse.VersionEnum} version
    */
    'version' = undefined;
    /**
    * 時刻
    * @member {Number} timestamp
    */
    'timestamp' = undefined;
    /**
    * @member {module:model/SensorV1RecordMeta} meta
    */
    'meta' = undefined;
    /**
    * データ
    * @member {Array.<Number>} data
    */
    'data' = undefined;



    /**
    * Allowed values for the <code>version</code> property.
    * @enum {Number}
    * @readonly
    */
    static VersionEnum = {
        /**
         * value: 1
         * @const
         */
        "1": 1    };

}
